import React, { useState, useEffect } from "react";
import Carousel from 'react-bootstrap/Carousel';
import Constants from "../Utilities/Constants";
import axios from "axios";


const Banners = ({galleryName}) => {
    const [gallery, setGallery] = useState([]);

    useEffect(() => {

        async function getGallery() {
            try {
                const response = await axios.get(`${Constants.API_URL_GET_GALLERY}/${galleryName}`);
                setGallery(response.data);
            } catch { }

        }

        getGallery();

    }, [galleryName]); 


    return (
        <div className="banner">
        <Carousel fade controls={false} indicators={false} >
                {gallery.map((image, index) => {
                    return (
                        <Carousel.Item key={index}>
                            <img src={`${Constants.IMAGE_URL}${image.fileName}`} alt={image.imageTitle}/>
                            <Carousel.Caption>
                                <h1>{image.imageTitle}</h1>
                            </Carousel.Caption>
                        </Carousel.Item>
                    )
                    })}
        </Carousel>
      </div>
    );
  }

  export default Banners;
